/**
 * Utility function that creates a debounced function that delays invoking the
 * given function until after the given timeout has elapsed. Each time the
 * debounced function is invoked the timeout is reset, thus delaying invocation
 * again.
 */
export default function debounce(func, wait) {
  let timeout

  function fn({ ...args }) {
    const context = this

    function later() {
      timeout = null
      func.call(context, args)
    }

    // reset the timeout by clearing the existing one...
    clearTimeout(timeout)

    // ...then creating a new one.
    timeout = setTimeout(later, wait)
  }

  // debounced function also has a cancel method, to cancel the timeout.
  fn.cancel = function cancel() {
    clearTimeout(timeout)
  }

  return fn
}
